module.exports = "<div class=\"login-view\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = 236
// module chunks = 1